import { render, staticRenderFns } from "./TradingGofx.vue?vue&type=template&id=acf16440&scoped=true&"
import script from "./TradingGofx.vue?vue&type=script&lang=js&"
export * from "./TradingGofx.vue?vue&type=script&lang=js&"
import style0 from "./TradingGofx.vue?vue&type=style&index=0&id=acf16440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf16440",
  null
  
)

export default component.exports